import script from "./contact-us.vue?vue&type=script&setup=true&lang=js"
export * from "./contact-us.vue?vue&type=script&setup=true&lang=js"

import "./contact-us.vue?vue&type=style&index=0&id=37b220b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37b220b6"]])

export default __exports__